import Button from '@liquidweb-dev/undercurrent/Button';
import EmptyState, {
	type EmptyStateProps,
} from '@liquidweb-dev/undercurrent/EmptyState';
import SearchIcon from '@liquidweb-dev/undercurrent/icons/lucide/Search';
import GlobeIcon from '@liquidweb-dev/undercurrent/icons/lucide/Globe';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import List, { ListProps } from '@liquidweb-dev/undercurrent/List';
import { Link } from 'react-router-dom';

export interface EmptyFilteredProps extends EmptyStateProps {
	onClearFilters: () => void;
}

const EmptyList = ({ sx, ...rest }: ListProps) => (
	<List
		sx={combineSx(
			{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			},
			sx,
		)}
		{...rest}
	/>
);

const Empty = (props: ListProps) => {
	return (
		<EmptyList {...props}>
			<EmptyState
				icon={
					<GlobeIcon
						sx={{
							height: ({ size }) => size.md,
							width: ({ size }) => size.md,
						}}
					/>
				}
				primaryButton={
					<Button
						variant="primary"
						color="highlight"
						size="large"
						component={Link}
						to="/shop/domain"
					>
						Register new
					</Button>
				}
				secondaryButton={
					<Button
						variant="secondary"
						size="large"
						// TODO: DEV-6158 Replace with new transfer domain dialog
						component={Link}
						to="/domain/create-transfer"
					>
						Transfer existing
					</Button>
				}
				sx={{ maxWidth: '264px' }}
			>
				It looks like you don&apos;t have any domains yet
			</EmptyState>
		</EmptyList>
	);
};

export const EmptyFiltered = ({
	sx,
	onClearFilters,
	...rest
}: EmptyFilteredProps) => {
	return (
		<EmptyList>
			<EmptyState
				icon={
					<SearchIcon
						sx={{
							height: ({ size }) => size.md,
							width: ({ size }) => size.md,
						}}
					/>
				}
				primaryButton={<Button onClick={onClearFilters}>Clear filters</Button>}
				sx={combineSx({ maxWidth: '264px' }, sx)}
				{...rest}
			>
				It looks like no items match those filters
			</EmptyState>
		</EmptyList>
	);
};

export default Empty;
